import React from 'react';
import { Star, StarBorderOutlined } from '../icons';
import QuestionNavigator from '../components/QuestionNavigator/QuestionNavigator';
import QuestionBlock, { QuestionOption } from '../components/QuestionBlock/QuestionBlock';
import { isValidOptionText } from '../utils/questionOptions';
import './QuestionsPage.css';

const SingleQuestionView = ({
  mock,
  questions,
  currentQuestionIndex,
  setCurrentQuestionIndex,
  selectedOptions,
  onOptionChange,
  markedForReview,
  onToggleReview,
  onToggleEliminated,
  onSubmit,
  submitting,
  getAnswers,
  getQuestionImageSrc
}) => {
  const totalQuestions = questions.length;
  const question = questions[currentQuestionIndex];
  const answeredCount = Object.keys(selectedOptions).length;
  const answeredPercent = totalQuestions > 0 ? Math.round((answeredCount / totalQuestions) * 100) : 0;
  const isFirst = currentQuestionIndex === 0;
  const isLast = currentQuestionIndex === totalQuestions - 1;

  if (!question) return null;

  const goPrev = () => setCurrentQuestionIndex(Math.max(0, currentQuestionIndex - 1));
  const goNext = () => setCurrentQuestionIndex(Math.min(totalQuestions - 1, currentQuestionIndex + 1));

  const getNavStatus = (index) => {
    const answered = selectedOptions[index] !== undefined;
    const marked = !!markedForReview[index];
    return [answered ? 'answered' : '', marked ? 'marked' : ''].filter(Boolean).join(' ');
  };

  return (
    <div className="single-question-layout">
      <QuestionNavigator
        className="no-print"
        title="Navegador"
        subtitle={mock?.name}
        count={totalQuestions}
        currentIndex={currentQuestionIndex}
        onSelect={setCurrentQuestionIndex}
        getStatus={getNavStatus}
        progress={{ percent: answeredPercent, label: `${answeredCount}/${totalQuestions} respondidas` }}
        legend={[
          { status: 'answered', label: 'Respondida' },
          { status: '', label: 'Não respondida' },
          { status: 'marked', label: 'Marcada p/ revisão' },
        ]}
      >
        <button
          type="button"
          className="single-question-submit-sidebar"
          onClick={onSubmit}
          disabled={submitting}
        >
          {submitting ? 'Enviando...' : 'Concluir simulado'}
        </button>
      </QuestionNavigator>

      <div className="single-question-main">
        <QuestionBlock
          counterText={`Questão ${currentQuestionIndex + 1} de ${totalQuestions}`}
          headerExtra={(
            <button
              type="button"
              className={`mark-review-btn no-print ${markedForReview[currentQuestionIndex] ? 'active' : ''}`}
              onClick={() => onToggleReview(currentQuestionIndex)}
            >
              {markedForReview[currentQuestionIndex] ? (
                <>
                  <Star style={{ fontSize: 16, verticalAlign: 'middle', marginRight: 4 }} />
                  Marcada para revisão
                </>
              ) : (
                <>
                  <StarBorderOutlined style={{ fontSize: 16, verticalAlign: 'middle', marginRight: 4 }} />
                  Marcar para revisão
                </>
              )}
            </button>
          )}
          subjectName={question.subjectName}
          title={question.title}
          imageSrc={question.image_url ? getQuestionImageSrc(question.image_url) : null}
          imageAlt={`Imagem da questão ${currentQuestionIndex + 1}`}
        >
          {question.questions.map((option, optionIndex) => {
            if (!isValidOptionText(option)) {
              return null;
            }
            const eliminated = question.eliminated && question.eliminated.includes(optionIndex);
            const selected = selectedOptions[currentQuestionIndex] === optionIndex;
            return (
              <QuestionOption
                key={optionIndex}
                index={optionIndex}
                letter={getAnswers(optionIndex).replace(')', '')}
                text={option}
                selectable
                selected={selected}
                disabled={eliminated}
                status={eliminated ? 'eliminated' : (selected ? 'selected' : '')}
                onSelect={(idx) => onOptionChange(currentQuestionIndex, option, idx)}
                onEliminate={(idx) => onToggleEliminated(currentQuestionIndex, idx)}
              />
            );
          })}
        </QuestionBlock>

        <div className="single-question-nav-buttons no-print">
          <button type="button" onClick={goPrev} disabled={isFirst}>
            ← Anterior
          </button>
          {isLast ? (
            <button type="button" onClick={onSubmit} disabled={submitting}>
              {submitting ? 'Enviando...' : 'Concluir simulado'}
            </button>
          ) : (
            <button type="button" onClick={goNext}>
              Próxima →
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SingleQuestionView;
